__turbopack_context__.v({
  "stale": "BoardDateline-module__v9YVjq__stale",
});
